import TableSortLabel from '@material-ui/core/TableSortLabel';
import PropTypes from 'prop-types';
import React from 'react';
import { IconSort } from '../../svg/Icons/IconSort';
import TableCell from './TableCell';

const IconComponent = (order) => () => <IconSort order={order} />;

export default function TableSortCell({ children, onChange, orderLabel, orderBy, orderDir, renderIcon = IconComponent, ...cellProps }) {
  const isActive = orderBy === orderLabel;

  const handleChange = React.useCallback(
    () => onChange([orderLabel, orderBy === orderLabel && orderDir === 'asc' ? 'desc' : 'asc']),
    [orderBy, orderDir, orderLabel, onChange]
  );

  return (
    <TableCell {...cellProps}>
      <TableSortLabel
        active={isActive}
        direction={orderDir || 'asc'}
        IconComponent={renderIcon(isActive ? orderDir : '')}
        onClick={handleChange}
      >
        {children}
      </TableSortLabel>
    </TableCell>
  );
}

TableSortCell.propTypes = {
  children: PropTypes.node,
  onChange: PropTypes.func,
  orderLabel: PropTypes.string,
  orderBy: PropTypes.string,
  orderDir: PropTypes.string,
  renderIcon: PropTypes.func,
};
